import { useState, useTransition } from "react";
import { toast } from "sonner";
import { Icone } from "@/components/Icone";
import { salvarInvestimentoAction } from "@/web/src/acoes";

const reais = (v: number | null) =>
  v === null ? null : v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/**
 * O gasto de mídia do mês, editável na própria linha da tabela.
 *
 * É o único número da conta que o sistema não descobre sozinho: ele vê a
 * conversa chegar, virar agendamento e a pessoa aparecer, mas não sabe quanto
 * custou fazer o celular tocar.
 */
export function GastoDoMes({ mes, gasto }: { mes: string; gasto: number | null }) {
  const [editando, setEditando] = useState(false);
  const [valor, setValor] = useState(gasto === null ? "" : String(gasto).replace(".", ","));
  const [pendente, iniciar] = useTransition();

  function salvar() {
    const n = Number(valor.replace(/\./g, "").replace(",", "."));
    if (!Number.isFinite(n) || n < 0) return toast.error("O gasto precisa ser um número igual ou maior que zero.");
    iniciar(async () => {
      const r = await salvarInvestimentoAction(mes, n, null);
      if (!r.ok) toast.error(r.erro);
      else setEditando(false);
    });
  }

  if (editando) {
    return (
      <span className="flex items-center gap-1.5">
        <input
          autoFocus
          value={valor}
          onChange={(e) => setValor(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") salvar();
            if (e.key === "Escape") setEditando(false);
          }}
          placeholder="2998,50"
          disabled={pendente}
          aria-label="Gasto em mídia do mês"
          className="h-8 w-28 rounded-[10px] border border-[var(--color-borda)] bg-[var(--color-painel)] px-2.5 text-sm text-[var(--color-tinta)] outline-none focus:border-[var(--color-marca)] focus:bg-[var(--color-cartao)]"
        />
        <button
          type="button"
          onClick={salvar}
          disabled={pendente}
          className="h-8 rounded-full bg-[var(--color-marca)] px-3 text-[13px] font-semibold text-[var(--color-sobre-marca)] hover:brightness-110 disabled:opacity-50"
        >
          OK
        </button>
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setEditando(true)}
      title="Mudar o gasto deste mês"
      className="group flex h-8 items-center gap-1.5 rounded-full px-2.5 text-left whitespace-nowrap transition-colors hover:bg-[var(--color-painel)]"
    >
      {gasto === null ? <span className="font-semibold text-[var(--color-marca-forte)]">informar</span> : <span className="num">{reais(gasto)}</span>}
      <Icone nome="editar" className="h-3.5 w-3.5 text-[var(--color-fraco)] opacity-60 group-hover:opacity-100" />
    </button>
  );
}
